import { isClientSide, isServerSide } from '@naturalcycles/js-lib'

export const isClientSideProd = isClientSide() && location.hostname === 'mudstudios.com'
export const isClientSideStaging = isClientSide() && location.hostname === 'mud-2024.web.app'
export const isClientSideDev = isClientSide() && !isClientSideProd && !isClientSideStaging

// process is undefined in the browser; import.meta.env is undefined under plain
// node/tsx (scripts) - hence the guards, so this module is importable everywhere.
const nodeEnv: Record<string, string | undefined> =
  typeof process === 'undefined' ? {} : process.env
const viteEnv = typeof import.meta.env === 'undefined' ? undefined : import.meta.env

export const isCI = !!nodeEnv['CI']
/**
 * True in the preview (SSR) deployment, where loaders run per request and serve
 * draft CMS content. Set at build time (`pnpm build-preview`) and at runtime by
 * the ssrPreview Cloud Function (see functions/src/index.ts).
 */
export const isPreview = !!nodeEnv['PREVIEW']
/** True during `react-router build` / prerendering (vite production build). */
export const isBuildTime = isServerSide() && !!viteEnv?.PROD
/** True in the `react-router dev` server (drafts enabled there, like on preview). */
export const isServerSideDev = isServerSide() && !!viteEnv?.DEV && !isCI && !isPreview

export let clientSideEnv = 'dev'
export let serverSideEnv = 'dev'

if (isClientSideProd) {
  clientSideEnv = 'prod'
} else if (isClientSideStaging) {
  clientSideEnv = 'staging'
}

if (isPreview) {
  serverSideEnv = 'preview'
} else if (isBuildTime) {
  serverSideEnv = 'build'
} else if (isCI) {
  serverSideEnv = 'ci'
}
